
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Box, Typography } from '@mui/material';

const insertLineBreaks = (text: string, maxLength: number = 60): string => {
  const words = text.split(' ');
  let line = '';
  const lines = [];

  for (const word of words) {
    if ((line + word).length > maxLength) {
      lines.push(line.trim());
      line = '';
    }
    line += word + ' ';
  }

  if (line) lines.push(line.trim());
  return lines.join('\n');
};

const ChatBubble = ({ sender, message }: { sender: string; message: string }) => {
  const isUser = sender === 'You';

  const formattedMessage = message.length > 80 ? insertLineBreaks(message, 60) : message;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        mb: 2,
        flexDirection: isUser ? 'row' : 'row-reverse',
        mx: 2.5,
      }}
    >
      {isUser ? (
        <AccountCircleIcon sx={{ fontSize: '48px', mr: 1.5 }} color="info" />
      ) : (
        <SmartToyIcon sx={{ fontSize: '48px', ml: 1.5 }} color="info" />
      )}
      <Box
        sx={{
          maxWidth: '70%',
          backgroundColor: isUser ? '#E3F2FD' : '#0053E2',
          borderRadius: 2,
          p: 1.5,
        }}
      >
        <Typography
          component="p"
          sx={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '12px',
            mb: '5px',
            color: isUser ? '#001e5f' : '#fff',
          }}
        >
          {sender}
        </Typography>
        <Typography
          component="p"
          sx={{
            fontWeight: '400',
            fontSize: '13px',
            lineHeight: '15px',
            color: isUser ? '#001e5f' : '#fff',
            whiteSpace: 'pre-line',
          }}
        >
          {formattedMessage}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChatBubble;
